export const DropdownPosition = {
    TOP_LEFT: "top_left",
    BOTTOM_LEFT: "bottom_left",
    TOP_RIGHT: "top_right",
    BOTTOM_RIGHT: "bottom_right",
}

export const DropdownSelectTypes = {
    PLACEHOLDER: "placeholder",
    VALUE: "value",
    INPUT: "input"
}